import React, { useCallback, useEffect, useMemo, useState } from "react";
import SinInformarTable from "./SinInformarTable";
import { COLUMNS } from "../Utils/ColumnsSinInformar";
import useLogin from "../../Autenticacion/Hooks/useLogin";
import { ObtenerArchivosSinInformar } from "../Services/ObtenerArchivosSinInformar";
import { EnumTablaPaginacion } from "../../../Utils/Enumeradores/ComunEnum";

const InformesSinInformar = (props) => {
	const {setRenderizar, renderizar} = props
	const [data, setData] = useState([]);
	const columns = useMemo(() => COLUMNS, []);
	const { usuario } = useLogin();
	const [pageCount, setPageCount] = useState(0);
	const [showAprobar, setShowAprobar] = useState(false);
	const [showEliminar, setShowEliminar] = useState(false);
	const [{ pageIndex, pageSize, sortBy }, setPagination] =
		useState({
			pageIndex: 0,
			pageSize: EnumTablaPaginacion.CantidadPaginacion,
			sortBy: []
		});

	const [valoresFormularioEnvio] = useState({
		paginacion: {
			numeroPagina: pageIndex
			, cantidadRegistros: pageSize
			, orderByAscending: false
			, ordenadoPor: "fechaCarga"
		},
		datosBusqueda: {
			idUsuario: usuario.id
		}
	});

	const postObtenerArchivosSinInformar = async (values) => {
		const resp = await ObtenerArchivosSinInformar(values);
		if (resp) {
			if (resp.status === 200) {
				setPageCount(resp.data.cantidadPaginas);
				setData(resp.data.listadoInformes);
			} else if (resp.status === 206) {
				setPageCount(0);
				setData([]);
			}
		}
	};


	const fetchData = useCallback(({ formulario, pageIndex, sortBy = []}) => {
		formulario.paginacion.numeroPagina = pageIndex + 1;
		formulario.paginacion.ordenadoPor = sortBy.length > 0 ? sortBy[0].id : formulario.paginacion.ordenadoPor;
		formulario.paginacion.orderByAscending = sortBy.length > 0 ? !sortBy[0].desc : formulario.paginacion.orderByAscending;
		postObtenerArchivosSinInformar(formulario);
	}, []);

	useEffect(() => {
		if (renderizar)
		{
			fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
			setPagination(values => ({
				...values,
				sortBy: sortBy
			}));
			setRenderizar(false)
		}
	}, [renderizar]);

	useEffect(() => {
			fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
			setPagination(values => ({
				...values,
				sortBy: sortBy
			}));
	}, [showEliminar, showAprobar]);

	return (
		<div>
			<div className="d-flex justify-content-between align-items-start mb-4 gap-3">
				<span className='d-flex flex-column align-items-start'>
					<h3 className="fs-3">Sin Informar</h3>
				</span>
			</div>
			
            <SinInformarTable
				columns={columns}
				data={data}
				fetchData={fetchData}
				pageCount={pageCount}
				currentpage={pageIndex}
				pageSize={pageSize}
				sortBy={sortBy}
				setPagination={setPagination}
				valoresFormularioEnvio={valoresFormularioEnvio}
				showEliminar={showEliminar}
				setShowEliminar={setShowEliminar}
				showAprobar={showAprobar}
				setShowAprobar={setShowAprobar}
			/>

		</div>
	)
}
export default InformesSinInformar;
